import GLightbox from 'glightbox'

const contentSlideHTML = `<div class="gslide">
    <div class="gslide-inner-content">
        <div class="ginner-container">
            <div class="gslide-media">
                <button class="gclose gbtn" tabindex="2" aria-label="Close">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M505.943,6.058c-8.077-8.077-21.172-8.077-29.249,0L6.058,476.693c-8.077,8.077-8.077,21.172,0,29.249C10.096,509.982,15.39,512,20.683,512c5.293,0,10.586-2.019,14.625-6.059L505.943,35.306C514.019,27.23,514.019,14.135,505.943,6.058z"></path></g></g><g><g><path d="M505.942,476.694L35.306,6.059c-8.076-8.077-21.172-8.077-29.248,0c-8.077,8.076-8.077,21.171,0,29.248l470.636,470.636c4.038,4.039,9.332,6.058,14.625,6.058c5.293,0,10.587-2.019,14.624-6.057C514.018,497.866,514.018,484.771,505.942,476.694z"></path>
                            </g>
                        </g>
                    </svg>
                </button>
            </div>
        </div>
    </div>
</div>`;

let addCustomCloseHandlers = function () {
    document.querySelectorAll('.glightbox-gated .gslide-inline > .gclose, .glightbox-leadership .gslide-inline > .gclose, .glightbox-content .gslide-inline > .gclose, .glightbox-content .modalActions .close').forEach(function (element) {
        element.addEventListener('click', function () {
            document.querySelector('.glightbox-gated .gcontainer > .gclose, .glightbox-leadership .gcontainer > .gclose, .glightbox-content .gcontainer > .gclose').dispatchEvent(new Event('click'));
        });
    });
};

function makeDefaultType() {
    const lightbox = GLightbox({
        selector: '.glightbox.default',
        draggable: false,
        touchNavigation: false,
        plyr: {
            css: 'https://unpkg.com/plyr@3.7.3/dist/plyr.css',
            js: 'https://unpkg.com/plyr@3.7.3/dist/plyr.js',
            config: {
                ratio: '16:9', // or '4:3'
                vimeo: {
                    byline: false,
                    portrait: false,
                    title: false,
                    speed: true,
                    transparent: false,
                    autoplay: true,
                    controls: false,
                    dnt: true,
                }
            },
        },
    });

    lightbox.on('slide_after_load', (data) => {
        // data is an object that contain the following
        const { slideNode, slideConfig } = data;

        // parse the vimeo url to get the video id and hash
        const vimeoUrl = slideConfig.href;
        const matches = vimeoUrl.match(/https:\/\/vimeo.com\/(\d+)\/([\d,a-f]+)/);

        // if there is no hash, return
        if (matches === null || !matches[2]) {
            return;
        }

        // build the player url
        let playerUrl = slideNode.querySelector('iframe').getAttribute('src');

        // replace the last segment after https://player.vimeo.com/video/
        playerUrl = playerUrl.replace(/https:\/\/player.vimeo.com\/video\/(\d+)/, 'https://player.vimeo.com/video/' + matches[1]);

        // append h param to the player url
        const playerUrlWithHash = playerUrl + '&h=' + matches[2];

        // update the player url in the iframe
        slideNode.querySelector('iframe').setAttribute('src', playerUrlWithHash);
    });
}

function makeGalleryType() {
    GLightbox({
        selector: '.lightboxGallery'
    });
}

function makeContentType() {
    const lightbox = GLightbox({
        selector: '.glightbox.content',
        slideHTML: contentSlideHTML,
        draggable: false,
        skin: 'content',
        touchNavigation: false,
        plyr: {
            css: 'https://unpkg.com/plyr@3.7.3/dist/plyr.css',
            js: 'https://unpkg.com/plyr@3.7.3/dist/plyr.js',
            config: {
                ratio: '16:9', // or '4:3'
                vimeo: {
                    byline: false,
                    portrait: false,
                    title: false,
                    speed: true,
                    transparent: false,
                    autoplay: true,
                    controls: false,
                    dnt: true,
                }
            }
        }
    });

    lightbox.on('open', function () {
        addCustomCloseHandlers();
    });
}

// function makeLeadershipType() {
//     const lightbox = GLightbox({
//         selector: '.glightbox.leadership',
//         slideHTML: contentSlideHTML,
//         closeButton: true,
//         draggable: false,
//         skin: 'leadership',
//         height: 'auto',
//         width: '100vw'
//     });

//     lightbox.on('open', function () {
//         addCustomCloseHandlers();
//     });
// }

// function makeSearchType() {
//     const slideHTML = `<div class="gslide">
//     <div class="gslide-inner-content">
//         <div class="ginner-container">
//             <div class="gslide-media search"></div>
//         </div>
//     </div>
// </div>`;

//    const search = GLightbox({
//        selector: '.glightbox.search',
//        slideHTML: slideHTML,
//        draggable: false,
//    });

//    search.on('open', function () {
//        document.querySelector('.gslide-media.search #search').focus();
//    });
// }

function makeGatedType() {
    const gated = GLightbox({
        selector: '.glightbox.gated',
        slideHTML: contentSlideHTML,
        draggable: false,
        height: 'auto',
        skin: 'gated'
    });

    gated.on('open', function () {
        addCustomCloseHandlers();

        document.querySelector('.glightbox-content .gated-content.cancel').addEventListener('click', function () {
            document.querySelector('.glightbox-content .gcontainer > .gclose').dispatchEvent(new Event('click'));
        });

        document.querySelector('.glightbox-content .gated-content.submit').addEventListener('click', function () {
            document.querySelector('.glightbox-content .gcontainer form').submit();
        });
    });
}

export const modals = () => {
    // document.addEventListener('DOMContentLoaded', function () {
        makeDefaultType();
        makeGalleryType();
        makeContentType();
        //makeLeadershipType();
        //makeSearchType();
        makeGatedType();
        //makeShareType();

        const shareModal  = document.querySelector('#share-modal');

        if (shareModal) {
            document.querySelector('#share-modal form .icon').addEventListener('click', function (e) {
                const input = e.currentTarget.previousElementSibling;
                input.select();
                input.setSelectionRange(0, 99999);
                document.execCommand('copy');

                const tooltip = e.currentTarget.parentElement.nextElementSibling;
                tooltip.classList.add('show');

                setTimeout(function () {
                    tooltip.classList.remove('show');
                }, 1500)
            });
        }
        
    // });
    const scrLock = Array.from(document.querySelectorAll('.scroll-lock'))
    const scrUnlock = Array.from(document.querySelectorAll('.scroll-unlock'))

    scrLock.forEach(el => {
    el.addEventListener('click', () => {
        document.querySelector('html').classList.add('body-scroll-lock')
    });
    })

    scrUnlock.forEach(el => {
    el.addEventListener('click', () => {
        document.querySelector('html').classList.remove('body-scroll-lock')
    });
    })
};
